import { Controller } from '@hotwired/stimulus'

// Connects to data-controller='dash-prefix'
export default class extends Controller {
  static targets = ['input']
  declare inputTargets: HTMLInputElement[]

  connect (): void {
    this.inputTargets.forEach((el: HTMLInputElement) => {
      el.addEventListener('input', this.addDash.bind(this))
    })
  }

  addDash (event: Event): void {
    const input = event.target as HTMLInputElement
    let value = input.value
    if (value.trim() === '') return
    if (!value.startsWith('-')) {
      value = '-' + value
      input.value = value
    }
  }
}
